import React, { useEffect, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import MessageBox from "./MessageBox";
import api from "../services/api.service";
import * as Styles from "../styles/AddPayment.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";
import { useParams } from "react-router-dom";

interface AddPaymentModalProps {
  isOpen: boolean;
  setSearchValueInput: (value: string) => void;
  onAccountBalance: () => void;
  onPayback: (paybackValue: number) => void;
  onRequestClose: () => void;
  setCustomerInfoByOrder: (value: any) => void;
}

const AddPaymentModal: React.FC<AddPaymentModalProps> = ({
  isOpen,
  setSearchValueInput,
  onAccountBalance,
  onPayback,
  onRequestClose,
  setCustomerInfoByOrder,
}) => {
  const {
    setSubsidiaryDataZustand,
    subsidiaryDataZustand,
    setOrderDataZustand,
    orderDataZustand,
    setMessageZustand,
    authUserZustand,
  } = useCombinedStore((state) => {
    return {
      setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      setOrderDataZustand: state.setOrderDataZustand,
      orderDataZustand: state.orderDataZustand,
      setMessageZustand: state.setMessageZustand,
      authUserZustand: state.authUserZustand,
    };
  });

  type EnteredValue = {
    paymentMethod: {
      paymentMethodUuid: string;
      paymentMethodType: string;
      paymentMethodName: string;
    };
    value: number;
  };
  type InputValue = {
    paymentMethod: {
      paymentMethodUuid: string;
      paymentMethodType: string;
      paymentMethodName: string;
    };
    value: any;
  };
  const [enteredValues, setEnteredValues] = useState<EnteredValue[]>([]);
  const [inputValues, setInputValues] = useState<InputValue[]>([]);
  const { saleOption } = useParams();

  const selectedSaleOption =
    subsidiaryDataZustand.selectedPdv.saleOptions.filter(
      (item) => item.itemInfoUuid === saleOption
    )[0];
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        const orderPayments = orderDataZustand.orderInfo?.orderPayments;
        const paymentMethods = subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodPayments?.PaymentMethods;
        if (orderPayments) {
          const enteredOrderValues = orderPayments.map((payment: any) => {
            return {
              paymentMethod: paymentMethods.find(
                (method: any) =>
                  method.paymentMethodUuid === payment.paymentMethodUuid
              ) ?? {
                paymentMethodUuid: "",
                paymentMethodType: "",
                paymentMethodName: "",
              },
              value: Number(payment.paymentValue),
            };
          });
          setEnteredValues((prevValues) => [
            ...prevValues,
            ...enteredOrderValues,
          ]);
        }
      }, 50);
    }
  }, [setOrderDataZustand, orderDataZustand, isOpen]);
  const paybackValue =
    (enteredValues.reduce(
      (sum, entry) => sum + Number(entry.value),
      0
    ) -
      (Number(orderDataZustand.totals?.total?.replace(",", ".")) || 0)) < 0
      ? ""
      : (enteredValues.reduce(
        (sum, entry) => sum + Number(entry.value),
        0
      ) -
        (Number(orderDataZustand.totals?.total?.replace(",", ".")) || 0)).toFixed(2).replace(".", ",")

  const cashPaybackValue: string = (enteredValues.reduce(
    (acc, enteredValue) => {
      if (enteredValue.paymentMethod.paymentMethodType === "cash") {
        return acc + enteredValue.value;
      }
      return acc;
    }
    , 0) - Number(orderDataZustand.totals?.total?.replace(",", "."))).toFixed(2).replace(".", ",");

  const handleSubmit = async () => {
    if (
      enteredValues.some((entry) => entry.paymentMethod?.paymentMethodName === "")
    ) {
      if (orderDataZustand.orderType === "3" && (orderDataZustand.orderStatus ?? 0) <= 1) {
        try {
          api.post(
            `printProduction/${orderDataZustand.orderUuid}/${subsidiaryDataZustand.selectedPdv.selectedPeriod.periodType}`
          );
          api.post(
            `printOrder/${orderDataZustand.orderUuid}/${selectedSaleOption.itemInfoValue.saleOptionPrinterAddress}`
          ); setOrderDataZustand({
            ...orderDataZustand,
            orderStatus: 2,
          });
        } catch (error: any) {
          if (error.message === "Network Error") {
            setMessageZustand(
              `Erro ao registrar pagamento, entre em contato com os administradores do Alfredo da sua unidade.`,
              `error`
            );
          } else {
            setMessageZustand(
              `Erro ao registrar pagamentos: ${error.message}`,
              `error`
            );
          }
        }
        setMessageZustand(`Pedido confirmado com sucesso!`, `success`);
        setEnteredValues([]);
        setInputValues([]);
        onRequestClose();
      }
      else {
        api.post(`closeOrder/${orderDataZustand.orderUuid}`);
        setEnteredValues([]);
        setInputValues([]);
        setMessageZustand(`Conta encerrada com sucesso!`, `success`);
        setSearchValueInput("");
        setOrderDataZustand({
          orderUuid: "",
          orderCode: "",
          orderOwnerUuid: "",
          orderOwnerName: "",
          orderStatus: 0,
          orderType: "",
          createdAt: "",
          orderInfo: {},
        });
        setCustomerInfoByOrder({
          customerName: "",
          customerAddress: "",
          customerAddressComplement: "",
          customerAddressObservation: "",
          customerOrigin: "",
          customerPhone: "",
        });
        onRequestClose();
      }
    }
    else if (
      enteredValues.reduce((sum, entry) => sum + Number(entry.value), 0) >=
      Number(orderDataZustand.totals?.total?.replace(",", "."))
    ) {
      if (orderDataZustand.orderType === "3" && (orderDataZustand.orderStatus ?? 0) <= 1) {
        try {
          api.post(`addOrderPayment/${orderDataZustand.orderUuid}`, {
            payments: enteredValues.map((entry) => {
              return {
                paymentMethodUuid: entry.paymentMethod.paymentMethodUuid,
                value: entry.value,
              };
            }),
          });
          api.post(
            `printProduction/${orderDataZustand.orderUuid}/${subsidiaryDataZustand.selectedPdv.selectedPeriod.periodType}`
          );
          api.post(
            `printOrder/${orderDataZustand.orderUuid}/${selectedSaleOption.itemInfoValue.saleOptionPrinterAddress}`
          );
          setOrderDataZustand({
            ...orderDataZustand,
            orderStatus: 2,
          });
        } catch (error: any) {
          if (error.message === "Network Error") {
            setMessageZustand(
              `Erro ao registrar pagamento, entre em contato com os administradores do Alfredo da sua unidade.`,
              `error`
            );
          } else {
            setMessageZustand(
              `Erro ao registrar pagamentos: ${error.message}`,
              `error`
            );
          }
        }
        setMessageZustand(`Pedido confirmado com sucesso!`, `success`);
        setEnteredValues([]);
        setInputValues([]);
        setSearchValueInput("");
        setOrderDataZustand({
          orderUuid: "",
          orderCode: "",
          orderOwnerUuid: "",
          orderOwnerName: "",
          orderStatus: 0,
          orderType: "",
          createdAt: "",
          orderInfo: {},
        });
        setCustomerInfoByOrder({
          customerName: "",
          customerAddress: "",
          customerAddressComplement: "",
          customerAddressObservation: "",
          customerOrigin: "",
          customerPhone: "",
        });
        onRequestClose();
      }
      else {
        if (
          enteredValues.some((entry) => entry.paymentMethod?.paymentMethodType === "cash") &&
          enteredValues.reduce((sum, entry) => sum + Number(entry.value), 0) >
          Number(orderDataZustand.totals?.total?.replace(",", "."))
        ) {
          setEnteredValues([]);
          onPayback(Number(cashPaybackValue.replace(",", ".")));
          return;
        }
        else {
          try {
            api.post(`addOrderPayment/${orderDataZustand.orderUuid}`, {
              payments: enteredValues.map((entry) => {
                return {
                  paymentMethodUuid: entry.paymentMethod.paymentMethodUuid,
                  value: entry.value,
                };
              }),
            });
            api.post(`closeOrder/${orderDataZustand.orderUuid}`);
          } catch (error: any) {
            if (error.message === "Network Error") {
              setMessageZustand(
                `Erro ao tentar encerrar a conta, entre em contato com os administradores do Alfredo da sua unidade.`,
                `error`
              );
            } else {
              setMessageZustand(
                `Erro ao encerrar a conta: ${error.message}`,
                `error`
              );
            }
          }
          setEnteredValues([]);
          setInputValues([]);
          setMessageZustand(`Conta encerrada com sucesso!`, `success`);
          setSearchValueInput("");
          setOrderDataZustand({
            orderUuid: "",
            orderCode: "",
            orderOwnerUuid: "",
            orderOwnerName: "",
            orderStatus: 0,
            orderType: "",
            createdAt: "",
            orderInfo: {},
          });
          setCustomerInfoByOrder({
            customerName: "",
            customerAddress: "",
            customerAddressComplement: "",
            customerAddressObservation: "",
            customerOrigin: "",
            customerPhone: "",
          });
          onRequestClose();
        }
      }

    } else {
      setMessageZustand(
        `Registre os pagamentos para poder encerrar a conta.`,
        `error`
      );
    }
  };
  const order = ['cash', 'card', 'valley', 'signature', 'other'];

  const orderedPaymentMethods = order.map((paymentType, paymentTypeIndex) => ({
    type: paymentType,
    index: paymentTypeIndex, // Adiciona o índice do tipo de pagamento
    methods: subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodPayments?.PaymentMethods
      ?.filter((method: any) => method.paymentMethodType === paymentType)
      ?.sort((a: { paymentMethodType: string }, b: { paymentMethodType: string }) =>
        order.indexOf(a.paymentMethodType) - order.indexOf(b.paymentMethodType)
      ),
  }));


  const handleKeydown = (
    event: React.KeyboardEvent<HTMLInputElement>,
    paymentMethod: {
      paymentMethodUuid: string;
      paymentMethodType: string;
      paymentMethodName: string;
    },
    currentTypeIndex: number, // Índice do tipo de pagamento
    currentMethodIndex: number // Índice do método no tipo
  ) => {
    if (event.key === "Enter") {
      const inputValue = Number(event.currentTarget.value);
      if (inputValue === 0) {
        const value = Math.max(
          0,
          (
            Number(orderDataZustand.totals?.total?.replace(",", ".")) -
            enteredValues.reduce(
              (sum, entry) =>
                sum + (Number(entry.value) ?? 0),
              0
            )
          )
        ).toFixed(2);

        setInputValues((prevValues: any) => [
          ...prevValues.filter(
            (iv: any) =>
              iv.paymentMethod.paymentMethodUuid !==
              paymentMethod.paymentMethodUuid
          ),
          { paymentMethod, value: value },
        ]);
      } else {
        setEnteredValues((prevValues) => [
          ...prevValues,
          { paymentMethod, value: inputValue },
        ]);
        setInputValues((prevValues) => [
          ...prevValues.map((iv) =>
            iv.paymentMethod.paymentMethodUuid === paymentMethod.paymentMethodUuid
              ? { ...iv, value: "" }
              : iv
          ),
        ]);
        event.currentTarget.value = inputValue.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
        });
      }
    } else if (event.key === "ArrowDown") {
      event.preventDefault();

      const nextIndex = currentMethodIndex + 1;
      const nextInput = document.getElementById(
        `paymentInput_${currentTypeIndex}_${nextIndex}`
      ) as HTMLInputElement;

      if (nextInput) {
        nextInput.select(); // Seleciona o valor para facilitar edição
      } else {
        // Caso não tenha mais métodos no tipo atual, move para o próximo tipo
        const nextTypeIndex = currentTypeIndex + 1;
        const nextTypeInput = document.getElementById(
          `paymentInput_${nextTypeIndex}_0`
        ) as HTMLInputElement;

        if (nextTypeInput) {
          nextTypeInput.select(); // Move para o primeiro método do próximo tipo
        }
      }
    } else if (event.key === "ArrowUp") {
      event.preventDefault();

      const prevIndex = currentMethodIndex - 1;
      const prevInput = document.getElementById(
        `paymentInput_${currentTypeIndex}_${prevIndex}`
      ) as HTMLInputElement;

      if (prevInput) {
        prevInput.select(); // Move para o método anterior no mesmo tipo
      } else {
        // Caso não tenha mais métodos no tipo atual, move para o último método do tipo anterior
        const previousTypeIndex = currentTypeIndex - 1;

        if (previousTypeIndex >= 0) {
          const prevTypeMethods = orderedPaymentMethods[previousTypeIndex]?.methods;

          if (prevTypeMethods?.length > 0) {
            const lastMethodIndex = prevTypeMethods.length - 1;
            const previousTypeInput = document.getElementById(
              `paymentInput_${previousTypeIndex}_${lastMethodIndex}`
            ) as HTMLInputElement;

            if (previousTypeInput) {
              previousTypeInput.select(); // Move para o último método do tipo anterior
            }
          }
        }
      }
    }
  };


  const handleAccountBalance = () => {
    setEnteredValues([]);
    onAccountBalance();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        setInputValues([]);
        onRequestClose();
      }}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <Styles.ModalWrapper>
        <Styles.CloseButton onClick={() => {
          setEnteredValues([]);
          setInputValues([]);
          onRequestClose();
        }}>
          &times;
        </Styles.CloseButton>
        <Styles.ModalContent>
          <Styles.ModalHeader
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
            <Styles.ModalTitle>Adicionar Pagamento</Styles.ModalTitle>
            <Styles.ModalDescription>
              Registre um pagamento para a conta.
            </Styles.ModalDescription>
          </Styles.ModalHeader>
          <Styles.ModalBody
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .backgroundColor
            }
          >
            <Styles.TableContainer>
              <Styles.TableWrapper>
                <Styles.Table>
                  <Styles.TableHeader>Formas de Pagamento</Styles.TableHeader>
                  <Styles.TableHeader>Digite o valor</Styles.TableHeader>
                  <Styles.TableBody>
                    {orderedPaymentMethods.map(({ type, index: typeIndex, methods }) => {
                      if (methods?.length > 0) {
                        return (
                          <>
                            <tr>
                              <Styles.TableHeader colSpan={2} id={`header_${typeIndex}`}>
                                {type === 'cash'
                                  ? 'Dinheiro'
                                  : type === 'card'
                                    ? 'Cartão'
                                    : type === 'valley'
                                      ? 'Contravale'
                                      : type === 'signature'
                                        ? 'Conta Assinada'
                                        : 'Outros Métodos de Pagamento'}
                              </Styles.TableHeader>
                            </tr>
                            {methods.map((method: any, methodIndex: number) => (
                              <Styles.TableRow key={method.paymentMethodUuid} id={`row_${typeIndex}_${methodIndex}`}>
                                <Styles.TableCell>{method.paymentMethodName}</Styles.TableCell>
                                <Styles.TableCell>
                                  <input
                                    style={{
                                      width: "100%",
                                    }}
                                    inputMode="decimal"
                                    pattern="[0-9]*"
                                    className="no-spinner"
                                    type="number"
                                    value={
                                      inputValues.find(
                                        (iv) =>
                                          iv.paymentMethod.paymentMethodUuid ===
                                          method.paymentMethodUuid
                                      )?.value?.toString() ?? ""
                                    }
                                    id={`paymentInput_${typeIndex}_${methodIndex}`}
                                    autoFocus={method?.paymentMethodType === "cash"}
                                    onKeyDown={(event) => {
                                      // Impede alteração pelo scroll do mouse
                                      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                                        event.preventDefault();
                                      }
                                      handleKeydown(event, method, typeIndex, methodIndex);
                                    }}
                                    onWheel={(e) => {
                                      // Bloqueia alteração pelo scroll do mouse
                                      (e.target as HTMLInputElement).blur();
                                    }}
                                    onChange={(event) => {
                                      const value = event.target.value;
                                      setInputValues((prevValues) => [
                                        ...prevValues.filter(
                                          (iv) =>
                                            iv.paymentMethod.paymentMethodUuid !==
                                            method.paymentMethodUuid
                                        ),
                                        {
                                          paymentMethod: method,
                                          value: value,
                                        },
                                      ]);
                                    }}
                                  />
                                </Styles.TableCell>
                              </Styles.TableRow>
                            ))}
                          </>
                        );
                      }
                    })}
                  </Styles.TableBody>
                </Styles.Table>
              </Styles.TableWrapper>
              <Styles.Divider />
              <Styles.TableWrapper>
                <Styles.Table>
                  <Styles.TableHeader>Forma de Pagamento</Styles.TableHeader>
                  <Styles.TableHeader>
                    Pagamentos Registrados
                  </Styles.TableHeader>
                  <Styles.TableBody>
                    {enteredValues.map((entry, index) => (
                      <Styles.TableRow key={index}>
                        <Styles.TableCell>
                          {entry.paymentMethod?.paymentMethodName === "" ? "Conta Corrente" : entry.paymentMethod?.paymentMethodName}
                        </Styles.TableCell>
                        <Styles.TableCell>{entry.value.toFixed(2).replace(".", ",")}
                          <Styles.TableRowRemoveButton onClick={() => setEnteredValues(
                            enteredValues.filter((_, i) => i !== index))}>
                            &times;
                          </Styles.TableRowRemoveButton>
                        </Styles.TableCell>
                      </Styles.TableRow>
                    ))}
                  </Styles.TableBody>
                  <Styles.TableFooter>
                    <Styles.TableFooterRow>
                      <Styles.TableFooterCell>Total da Conta</Styles.TableFooterCell>
                      <Styles.TableFooterCell>
                        {orderDataZustand.totals?.total}
                      </Styles.TableFooterCell>
                    </Styles.TableFooterRow>
                    <Styles.TableFooterRow>
                      <Styles.TableFooterCell>Pagamentos Registrados</Styles.TableFooterCell>
                      <Styles.TableFooterCell>
                        {enteredValues.reduce(
                          (sum, entry) => sum + Number(entry.value),
                          0
                        ).toFixed(2).replace(".", ",")}
                      </Styles.TableFooterCell>
                    </Styles.TableFooterRow>
                    <Styles.TableFooterRow>
                      <Styles.TableFooterCell>Troco</Styles.TableFooterCell>
                      <Styles.TableFooterCell>
                        {enteredValues.reduce(
                          (sum, entry) => sum + Number(entry.value),
                          0
                        ) > (Number(orderDataZustand.totals?.total?.replace(",", ".")) || 0) ?
                          (
                            (enteredValues.reduce(
                              (sum, entry) => sum + Number(entry.value),
                              0
                            ) - (Number(orderDataZustand.totals?.total?.replace(",", ".")) || 0))
                              .toFixed(2)
                              .replace(".", ",")
                          ) : "0,00"}
                      </Styles.TableFooterCell>
                    </Styles.TableFooterRow>
                    <Styles.TableFooterRow>
                      <Styles.TableFooterCell>Saldo Restante</Styles.TableFooterCell>
                      <Styles.TableFooterCell>
                        {Math.max(
                          0,
                          Number(orderDataZustand.totals?.total?.replace(",", ".")) -
                          enteredValues.reduce(
                            (sum, entry) => sum + (parseFloat(String(entry.value)) || 0),
                            0
                          )
                        ).toFixed(2).replace(".", ",")}
                      </Styles.TableFooterCell>
                    </Styles.TableFooterRow>
                  </Styles.TableFooter>
                </Styles.Table>
              </Styles.TableWrapper>
            </Styles.TableContainer>
          </Styles.ModalBody>
          <Styles.ModalFooter
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Button onClick={handleAccountBalance} opacity="0.8">Conta Corrente</Styles.Button>
            <div style={{ display: "flex" }}>
              <Styles.Button opacity="0.8" onClick={() => {
                setEnteredValues([]);
                setInputValues([]);
                onRequestClose();
              }}>
                Cancelar
              </Styles.Button>
              <Styles.Button
                opacity={
                  enteredValues.reduce(
                    (sum, entry) => sum + Number(entry.value),
                    0
                  ) >= Number(orderDataZustand.totals?.total?.replace(",", "."))
                    ? "1"
                    : "0.2"
                }
                onClick={handleSubmit}
              >
                {orderDataZustand.orderType === "3" && (orderDataZustand.orderStatus ?? 0) <= 1
                  ? "Confirmar Conta"
                  : "Fechar Conta"}
              </Styles.Button>
            </div>
          </Styles.ModalFooter>
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal >
  );
};

export default AddPaymentModal;

/* Remove spinner arrows from number inputs in all browsers */
const style = document.createElement('style');
style.innerHTML = `
  input.no-spinner::-webkit-outer-spin-button,
  input.no-spinner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input.no-spinner[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`;
document.head.appendChild(style);
